import { FC } from 'react'

export const Counter: FC<{
    state: [number, React.Dispatch<React.SetStateAction<number>>]
    title?: string
    min?: number
    max?: number
}> = ({ state, title, min, max }) => {
    const [count, setCount] = state
    const isMin = count <= (min || 0)
    const isMax = count >= (max || 1000)

    function increment() {
        if (isMax) return
        setCount(count + 1)
    }
    function decrement() {
        if (isMin) return
        setCount(count - 1)
    }

    return (
        <div className="counter">
            {title ? <div className="counter__title">{title}</div> : null}
            <div className="counter__body">
                <div
                    className={`counter__btn ${
                        isMin ? 'counter__btn-disabled' : ''
                    }`}
                    onClick={decrement}
                >
                    <i className="fas fa-minus"></i>
                </div>
                <div className="counter__field">{count}</div>
                <div
                    className={`counter__btn ${
                        isMax ? 'counter__btn-disabled' : ''
                    }`}
                    onClick={increment}
                >
                    <i className="fas fa-plus"></i>
                </div>
            </div>
        </div>
    )
}
